// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__axjLh","red":"Alert_red__IVMow","green":"Alert_green__rnR05","errorImg":"Alert_errorImg__dz69j","hidden":"Alert_hidden__TpIpB","visible":"Alert_visible__5aspY"};